export default "__VITE_ASSET__Cpvx$pCN__"